import React, {Component} from 'react';
import 'regenerator-runtime/runtime';
import {TabContent, TabPane, Nav, NavItem, NavLink, Progress, Label, Input} from 'reactstrap';
import classnames from 'classnames';
import axios from 'axios';
import Constants from '../../Components/Constants'
import AuthStore from '../../stores/AuthStore';

import history from '../../history';

class Aside extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.openExam = this.openExam.bind(this);

    this.state = {
      activeTab: '1',
        
        searchFilter: {
          firstResult: 0,
          maxResults: 100,

          reportStatus: "0",
          examRegister: "",
          clientName: "",
          patientName: "",
          beginExecutionDate: "",
          endExecutionDate: "",
          beginReceptionDate: "",
          endReceptionDate: "",
          beginReportDate: "",
          endReportDate: "",
          pediatricOnly: false,
          reportSearchText: "",
          genericSearchText: "",
          lowPriorityOnly: false,
          excludeLowPriorityExams: false
        }
    };
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }
    
    componentDidMount(){
        if(AuthStore.getState().user.profile == "M"){
            const interval = setInterval(() => {
                axios({
                  method: 'post',
                  url: Constants.apiUrl+'/api/v1/exam/doctor/light/'+AuthStore.getState().user.entity_id,
                  data: this.state.searchFilter
              })
              .then(response => {
                 this.setState({
                     examList: response.data
                 });
              });
            }, 5000);
            return () => clearInterval(interval);
        }
    }

    openExam(examId){
        history.push('/examViewer/'+examId);    
    }
  
    render() {
    if(this.state.examList == null) return ("");
    if(AuthStore.getState().user.profile != "M") return "";

    let exams = this.state.examList.map((exam) =>
        <div className="message" key={exam.id}  onClick={function(){this.openExam(exam.id)}.bind(this)}>
          <div>
            <small className="text-muted"><b>{exam.patientFullName}</b></small>
            <small className="text-muted float-right mt-1">{exam.publicId}</small>
          </div>

          <small className="text-muted">
            {exam.status == "EXAM_STATUS_WAITING_REPORT" ? "Em laudo" : "Aguardando laudo"}
          </small>
        <hr/>
      </div>
    );

    return (
      <aside className="aside-menu">
        <Nav tabs>
          <NavItem>
            <NavLink className={classnames({ active: this.state.activeTab === '1' })}
                     onClick={() => { this.toggle('1'); }}>
              <i className="icon-speech"></i>
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={this.state.activeTab}>

          <TabPane tabId="1" className="p-3">
            {exams}
          </TabPane>
        </TabContent>
      </aside>
    )
  }
}

export default Aside;



// WEBPACK FOOTER //
// ./src/components/Aside/Aside.js